import TournamentClassification from '@features/tournament-details/tournament-classification/tournament-classification';
export default TournamentClassification;
